<div class="note">
  <div>
    <span class="user-author">
      @if(note().user; as user) {
        {{ user.lastName }} {{ user.firstName }}
      } @else {
        System
      }
    </span>
    <span class="note-date">{{ note().timeStamp | date : 'medium' }}</span>
  </div>
  <div class="note-text">
    {{ note().textValue }}
  </div>
</div>
